// extracted by mini-css-extract-plugin
export default {"wrapper":"cEjc1WPal9TYpHiFERSE","content":"BP8PQOdA7zEm5aa3feBe"};